import React from "react";
import Navbar from "../components/Navbar";
import Marketing from "../components/Marketing";
import Footer from "../components/Footer";

export default function MarketingPage() {
  return (
    <div className="App" data-testid="marketing-page">
      <Navbar />
      <main className="pt-20">
        <Marketing />
      </main>
      <Footer />
    </div>
  );
}
